import Api from "~/service/Api";

class Immersive3dTourWithZipProcessRepository {
  update(tourId, data) {
    return Api.post(`/immersive-3d-tour/with-zip-processes/${tourId}`, data);
  }
}

export default Immersive3dTourWithZipProcessRepository;
